import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BusinessPartnerProviderConfig } from '../../../model/provider';

@Component({
  selector: 'app-provider-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './provider-card.html',
  styleUrl: './provider-card.css'
})
export class ProviderCard {
  @Input({ required: true }) provider!: BusinessPartnerProviderConfig;
  @Output() editProvider = new EventEmitter<BusinessPartnerProviderConfig>();
  @Output() deleteProvider = new EventEmitter<BusinessPartnerProviderConfig>();

  protected onEdit(): void {
    this.editProvider.emit(this.provider);
  }

  protected onDelete(): void {
    this.deleteProvider.emit(this.provider);
  }
}
